// extracted by mini-css-extract-plugin
export default {"button":"styles_button__QzcsU","primary":"styles_primary__uz3gq"};